module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payTitulos":["Encuentra un partner para que te ayude con todos los tipos de pago"]},"es":{"payTitulos":["Encuentra un partner para que te ayude con todos los tipos de pago"]}}')
  delete Component.options._Ctor
}
